<div class="content-body m-3" >
  <div class="row m-3">
      <div class="col-12 text-center">
          <h4>ที่อยู่จัดส่งเอกสาร</h4>
      </div>
  </div>
  <div class="row centered-content">
      <div class="col-12 col-lg-10">
            <div class="row m-2">
              <div class="col-sm-6">
                  <div class="row">
                      <div class="col-md-4 text-right">
                          <label class="required">ชื่อ</label>
                      </div>
                      <div class="col-md-8">
                          <input type="text" class="form-control"  [(ngModel)]="nameall" >
                          <span class="text-danger" *ngIf="  submitted && ( nameall.trim().length == 0  || submittedType ) ">
                            กรุณาระบุ ชื่อ-นามสกุล
                          </span>
                      </div>
                  </div>
              </div>
          </div>
          <div class="row m-2">
              <div class="col-sm-6">
                  <div class="row">
                      <div class="col-md-4 text-right">
                          <label class="required">เลขที่</label>
                      </div>
                      <div class="col-md-8">
                          <input type="text" class="form-control"  [(ngModel)]="contact.dpa_contact_homeno" >
                          <span class="text-danger" *ngIf="  submitted && ( contact.dpa_contact_homeno.trim().length == 0 || submittedType  )">
                            กรุณาระบุ เลขที่
                          </span>
                      </div>
                  </div>
              </div>
              <div class="col-sm-6">
                  <div class="row">
                      <div class="col-md-4 text-right">
                          
                      </div>
                      <div class="col-md-8">
                          
                      </div>
                  </div>
              </div>
          </div>
          <div class="row m-2">
              <div class="col-sm-6">
                  <div class="row">
                      <div class="col-md-4 text-right">
                          <label>หมู่ที่</label>
                      </div>
                      <div class="col-md-8">
                          <input type="text" class="form-control" [(ngModel)]="contact.dpa_contact_moo"> 
                      </div>
                  </div>
              </div>
              <div class="col-sm-6">
                  <div class="row">
                      <div class="col-md-4 text-right">
                          <label>ถนน</label>
                      </div>
                      <div class="col-md-8">
                          <input type="text" class="form-control" [(ngModel)]="contact.dpa_contact_street"> 
                      </div>
                  </div>
              </div>
          </div>
          <div class="row m-2">
              <div class="col-sm-12">
                  <div class="row">
                      <div class="col-md-2 text-right">
                          <label class="required">ค้นหาที่อยู่ของคุณ</label>
                      </div>
                      <div class="col-md-10">
                          <select class="form-control select2" style="width: 100%;" id="SelectAddress">
                              <option value="">เลือก</option>
                              <option *ngFor="let sd of AddressList" [value]="sd.id">
                                  {{sd.text}}
                              </option>
                          </select>
                      </div>
                  </div>
              </div>
          </div>
          <div class="row m-2">
              <div class="col-sm-6">
                  <div class="row">
                      <div class="col-md-4 text-right">
                          <label class="required">ตำบล/แขวง</label>
                      </div>
                      <div class="col-md-8">
                          <input type="text" class="form-control" readonly [(ngModel)]="contact.dpa_contact_subdistictname">
                          <span class="text-danger" *ngIf="  submitted && ( contact.dpa_contact_subdistictname.trim().length == 0  || submittedType) ">
                            กรุณาระบุ ตำบล/แขวง
                          </span>
                      </div>
                  </div>
              </div>
              <div class="col-sm-6">
                  <div class="row">
                      <div class="col-md-4 text-right">
                          <label class="required">อำเภอ/เขต</label>
                      </div>
                      <div class="col-md-8">
                          <input type="text" class="form-control" readonly [(ngModel)]="contact.dpa_contact_distictname">
                          <span class="text-danger" *ngIf="  submitted && ( contact.dpa_contact_distictname.trim().length == 0  || submittedType ) ">
                            กรุณาระบุ อำเภอ/เขต
                          </span>
                      </div>
                  </div>
              </div>
          </div>
          <div class="row m-2">
              <div class="col-sm-6">
                  <div class="row">
                      <div class="col-md-4 text-right">
                          <label class="required">จังหวัด</label>
                      </div>
                      <div class="col-md-8">
                          <input type="text" class="form-control" readonly [(ngModel)]="contact.dpa_contact_provincname">
                          <span class="text-danger" *ngIf="  submitted && ( contact.dpa_contact_provincname.trim().length == 0  || submittedType ) ">
                            กรุณาระบุ จังหวัด
                          </span>
                      </div>
                  </div>
              </div>
              <div class="col-sm-6">
                  <div class="row">
                      <div class="col-md-4 text-right">
                          <label class="required">รหัสไปรษณีย์</label>
                          
                      </div>
                      <div class="col-md-8">
                          <input type="text" class="form-control" readonly [(ngModel)]="contact.dpa_contact_postcodename">
                          <span class="text-danger" *ngIf="  submitted && ( contact.dpa_contact_postcodename.trim().length == 0  || submittedType ) ">
                            กรุณาระบุ รหัสไปรษณีย์
                          </span>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>

  <br />
  
  <div class="row centered-content">
      <div class="col-md-8">
          <table id="TableDocs" style="width: 100%;" class="table table-bordered table-hover result-table">
              <thead>
                <tr>
                  <th  class="checkbox-col">
                    <input type="checkbox" [(ngModel)]="isCheckedAll" (change)="onCheckAllChange()">
                  </th>
                  <th>เลขที่คำขอ</th>
                  <th>ประเภทคำขอ</th> 
                  <th>สถานะ</th>
                  <th class="colhidden"></th>
                </tr>
              </thead>
              <tbody id="tbcrm03">
                <tr *ngFor="let c of contactList; let i = index">
                  <td align="center" class="checkbox-col">
                    <input type="checkbox" class="row-checker" value="{{c.RequestedNo}}" name="{{c.FilePath}}">
                  </td>
                  <td>{{c.RequestedNo}}</td>
                  <td>{{c.RequestType}}</td> 
                  <td>{{c.isPrintMessage}}</td> 
                  <th class="colhidden">{{c.isPrint}}</th>
                  <th class="colhidden">{{c.FilePath}}</th>
                </tr>
              </tbody>
          </table>
      </div>

      <div class="col-12 centered-content">
        &nbsp;
      </div>


      <div class="col-12 centered-content">
        <button class="btn btn-default" (click)="senddata(1)" >พิมพ์เอกสาร</button> &nbsp;
        <button class="btn btn-default" (click)="senddata(2)">จัดส่งเอกสาร</button> &nbsp; 
     </div>
     
     <div class="col-12 centered-content">
      &nbsp;
    </div>

    <!-- Modal detail-->
<div class="modal" [ngStyle]="{'display':displayStyle}"aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-m">
      <div class="modal-content">
  
        <div class="modal-body" style="background-color: #f0f3f7">
  
          <div class="row mt-3">
            <div class="col-12 text-center">
              <h5 class="modal-title" style="font-weight: bold">ยืนยันตัวตนผ่านรหัส OTP</h5>
            </div>
          </div>
  
          <div class="row mt-3">
            <div class="col-3 offset-md-1 text-right">
              <label class="font-weight-bold">เบอร์โทรศัพท์</label>
            </div>
            <div class="col-6">
              <input type="text" class="form-control" [(ngModel)]="telephone1" >
            </div>
            <!-- <div class="col-4 input-group my-auto">
              <label style="font-size: 1.2rem;">OTP Ref:</label>
              <label style="font-size: 1.2rem;" class="text-danger">
                {{otpRef}}
              </label>
              <label class="ml-3">Password:</label>
              <input type="text" class="form-control" [(ngModel)]="verifyOtp">
              <button class="btn btn-primary" (click)="verify()" [disabled]="verifyOtp.trim().length == 0">
                Verify {{OTPCountDown}}
              </button>
            </div> -->
          </div>
          <div class="row mt-3">
            <div class="col-3 offset-md-1 text-right">
              &nbsp;
            </div>
            <div class="col-3">
              <button class="btn btn-primary w-100" (click)="requestOtp()" [disabled]="disableResentOtp">
                ขอรหัส OTP 
              </button>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-3 offset-md-1 text-right">
              <label>OTP Ref:</label>
            </div>
            <div class="col-6">
              <label>
                {{otpRef}}
              </label>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-3 offset-md-1 text-right">
              <label class="font-weight-bold">รหัส OTP</label>
            </div>
            <div class="col-6">
              <input type="text" class="form-control" [(ngModel)]="verifyOtp"  [disabled]="otpRef.trim().length == 0">
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-3 offset-md-1 text-right">
              &nbsp;
            </div>
            <div class="col-3">
              <button class="btn btn-primary w-100" (click)="verify()" [disabled]="verifyOtp.trim().length == 0">
                ยืนยันรหัส OTP 
              </button>
            </div>
          </div>
  
          <div class="row mt-5 mb-2">
            <div class="col-12 text-center">
              <button type="button" class="btn btn-info" data-dismiss="modal" (click)="close()">ปิด</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
<br />



// WEBPACK FOOTER //
// ./src/app/req-document/req-document.component.html